export const ADD_NEW_PHYSICAL_INVENTORY = "ADD_NEW_PHYSICAL_INVENTORY";
export const ADD_NEW_PHYSICAL_INVENTORY_SUCCESS = "ADD_NEW_PHYSICAL_INVENTORY_SUCCESS";
export const EDIT_PHYSICAL_INVENTORY = "EDIT_PHYSICAL_INVENTORY";
export const EDIT_PHYSICAL_INVENTORY_SUCCESS = "EDIT_PHYSICAL_INVENTORY_SUCCESS";
export const DELETE_PHYSICAL_INVENTORY = "DELETE_PHYSICAL_INVENTORY";
export const DELETE_PHYSICAL_INVENTORY_SUCCESS = "DELETE_PHYSICAL_INVENTORY_SUCCESS";